import styled from 'styled-components'

const StyledCommunityView = styled.div`
  iframe {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`

export default StyledCommunityView
